<div class="banner">
  <img class="icon" [src]="'assets/icons/grey/Information Circle.svg'" alt="" />
  <div i18n>Updates pending. The info in this section does not reflect any change requests.</div>
</div>
